  /* Simple jQuery Equal Heights @version 1.5.1. Copyright (c) 2013 Matt Banks. Dual licensed under the MIT and GPL licenses. */
!function (a) {
  a.fn.equalHeights = function () {
    var b = 0, c = a(this);
    return c.each(function () {
      var c = a(this).innerHeight();
      c > b && (b = c)
    }), c.css("height", b)
  }, a("[data-equal]").each(function () {
    var b = a(this), c = b.data("equal");
    b.find(c).equalHeights()
  })
}(jQuery);

/* Run function after window resize */
var afterResize = (function () {
  var t = {};
  return function (callback, ms, uniqueId) {
    if (!uniqueId) {
      uniqueId = "Don't call this twice without a uniqueId";
    }
    if (t[uniqueId]) {
      clearTimeout(t[uniqueId]);
    }
    t[uniqueId] = setTimeout(callback, ms);
  };
})();

window.theme = window.theme || {};

theme.cacheSelectors = function () {
  theme.cache = {
    // General
    $w: $(window),
    $body: $('body'),

    // Mobile Nav
    $mobileNavTrigger: $('#MobileNavTrigger'),
    $mobileNav: $('#MobileNav'),
    $mobileSublistTrigger: $('.mobile-nav__sublist-trigger'),

    // Equal height elements
    $productGridImages: $('.grid-link__image--product'),
    $featuredGridImages: $('.grid-link__image--collection'),

    // Product page
    $productImage: $('#ProductPhotoImg'),
    $productImageGallery: $('.gallery__item'),

    // Custom slider on product page
    $sliderImage: $('.product_photo_img'),

    // Cart Page
    cartNoteAdd: '.cart__note-add',
    cartNote: '.cart__note',

    // Add to cart - Ajax
    $cartCount: $('.cart-count'),
    $addToCartBtn: $('form[action^="/cart/add"] :submit'),

    //Navigation
    $hasDropdownItem: $('.site-nav--has-dropdown')
  }
};

timber.cacheVariables = function () {
  timber.vars = {
    isTouch: timber.cache.$html.hasClass('supports-touch')
  }
};

theme.init = function () {
  theme.cacheSelectors();
  theme.mobileNav();
  timber.cacheVariables();
  theme.equalHeights();
  theme.cartPage();
  theme.toggleMenu();

  
  theme.productImageGallery();
  

  
  theme.enableAjax();
  
};

theme.mobileNav = function () {
  theme.cache.$mobileNavTrigger.on('click', function () {
    theme.cache.$mobileNav.slideToggle(220);
  });

  theme.cache.$mobileSublistTrigger.on('click', function (evt) {
    var $el = $(this);

    // Enable commented out if statement to allow direct clicking on trigger link
    // if (!$el.hasClass('is-active')) {
    evt.preventDefault();
    $el.toggleClass('is-active').next('.mobile-nav__sublist').slideToggle(200);
    // submenu
    $el.next('.mobile-nav__sublist').find('.mobile-nav__sublist-trigger').addClass('is-active').next('.mobile-nav__sublist').slideDown(200);
    // }
  });
};

theme.equalHeights = function () {
  theme.cache.$w.on('load', resizeElements());

  theme.cache.$w.on('resize',
    afterResize(function () {
      resizeElements();
    }, 250, 'equal-heights')
  );

  function resizeElements () {
    theme.cache.$productGridImages.css('height', 'auto').equalHeights();
    theme.cache.$featuredGridImages.css('height', 'auto').equalHeights();
  }
};

theme.productImageGallery = function () {

  if (!theme.cache.$productImageGallery.length) {
    return;
  }
  ;

  theme.cache.$productImageGallery.magnificPopup({
    type: 'image',
    mainClass: 'mfp-fade',
    closeOnBgClick: true,
    closeBtnInside: true,
    closeOnContentClick: false,
    tClose: '',
    removalDelay: 500,
    callbacks: {
      open: function () {
        $('html').css('overflow-y', 'hidden');
      },
      close: function () {
        $('html').css('overflow-y', '');
      }
    },
    gallery: {
      enabled: false,
      navigateByImgClick: false,
      arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><span class="mfp-chevron mfp-chevron-%dir%"></span></button>',
      tPrev: 'Previous (Left arrow key)',
      tNext: 'Next (Right arrow key)'
    }
  });

  theme.cache.$productImage.bind('click', function () {
    var imageId = $(this).attr('data-image-id');
    theme.cache.$productImageGallery.filter('[data-image-id="' + imageId + '"]').trigger('click');
  });

  // Custom Product page slider bind
  theme.cache.$sliderImage.bind('click', function () {
    var imageId = $(this).attr('data-image-id');
    theme.cache.$productImageGallery.filter('[data-image-id="' + imageId + '"]').trigger('click');
  });
};

theme.cartPage = function () {
  

  theme.cache.$body.on('click', theme.cache.cartNoteAdd, function () {
    $(this).addClass('is-hidden');
    $(theme.cache.cartNote).addClass('is-active');
    ajaxifyShopify.sizeDrawer();
  });

  let GWP_boh_runga = localStorage.getItem('GWP_boh_runga');
  let bohRungaGiftComponent = $(".boh-runga__gift-wrap");
  let removeBohRungaGift = $("#GWP__boh-runga-remove-it");
  let bohRungaGiftInputAtr = $("#GWP__boh-runga");

  if(GWP_boh_runga != "No" && bohRungaGiftInputAtr.val() !== 'No'){
    bohRungaGiftComponent.removeClass("hide");
  } else {
    bohRungaGiftInputAtr.val("No");
  }

  removeBohRungaGift.click(function(event) {
    event.preventDefault();
    bohRungaGiftInputAtr.val("No");
    bohRungaGiftComponent.addClass("hide");
    localStorage.setItem('GWP_boh_runga', 'No');
  });

};

theme.backButton = function () {
  var referrerDomain = urlDomain(document.referrer);
  var shopDomain     = urlDomain(document.url);

  // If in quick view product, simply close the popup
  if ($('.template-collection .product-single').length > 0) {
    $.magnificPopup.close();
    return false;
  }

  if (shopDomain === referrerDomain) {
    history.back();
    return false;
  }

  function urlDomain (url) {
    var a  = document.createElement('a');
    a.href = url;
    return a.hostname;
  }
};

theme.popupReminder = function () {
  let product_tags  = JSON.parse(document.querySelector('.product-tags-json').innerText)
  let reminder_tags = JSON.parse(document.querySelector('.product-reminder-tags-json').innerText)
  if (!product_tags || !reminder_tags) return

  // Find matches
  let tags_found = []
  product_tags.forEach(function (product_tag) {
    reminder_tags.forEach(function (reminder_tag) {
      if (product_tag.trim() == reminder_tag.trim()) {
        tags_found.push(reminder_tag)
      }
    })
  })

  // Set popup src
  let src = '.reminder-pre-loved-popup'

  if (product_tags.includes('last-chance')) {
    src = '.reminder-last-chance-popup'
  }

  let promo_found = false;

  if (product_tags.includes('add-to-cart-promo')) {
    promo_found = true
    src = '.add-to-cart-promo-popup'
  }

  if (!tags_found.length && !promo_found) return

  // Display popup
  $.magnificPopup.open({
    items: [
      { src: src, type: 'inline' }
    ],
    gallery       : { enabled: false },
    closeBtnInside: false,
    modal         : true,
    mainClass     : 'mfp-fade'
  });

  // Close popups
  $('.reminder-popup-close').on('click', function () {
    $.magnificPopup.close();
  })
};

theme.addToCartflip = function ($addToCartBtn) {

  // Get label of add to cart button
  var addToCartText = $addToCartBtn.attr('data-add-to-cart') || "Add to Cart";

  // Make a copy of the add to cart button should we flip it
  $addToCartBtn
    .clone(true)
    .prop('disabled', false)
    .removeClass('disabled')
    .addClass('btn--unflipped')
    .find('span')
    .text(addToCartText)
    .end()
    .hide()
    .insertAfter($addToCartBtn);

  $addToCartBtn
    .unbind('click')
    .removeClass('disabled')
    .find('span')
    .text("View cart")
    .end()
    .bind('click', function (e) {
      e.preventDefault();
      window.location.href = '/cart';
    })
    .prop('disabled', false)
    .addClass('btn--flipped');
    // .after('<span class="continue-shopping"> <a class="btn--secondary" href="/collections/all">Continue shopping</a></span>');

  $('.continue-shopping a').bind('click', theme.backButton);

  // Unflip button if another variant is selected
  $('.single-option-selector, [name="quantity"]').bind('click', function () {
    $(this).closest('form').find('.btn--flipped, .continue-shopping, .note').remove();
    $(this).closest('form').find('.btn--unflipped').removeClass('.btn--unflipped').show();
  });
};

theme.enableAjax = function () {
  theme.cache.$addToCartBtn.bind('click', function (e) {

    e.preventDefault();

    $('.note.errors').remove();

    var $addToCartBtn     = $(this),
        $addToCartForm    = $(this).closest('form'),
        $addToCartBtnText = $(this).find('span');

    if ($addToCartForm.length) {
      $addToCartBtn
        .attr('data-add-to-cart', $addToCartBtnText.text())
        .prop('disabled', true)
        .addClass('disabled')
        .addClass('btn--loading');
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: $addToCartForm.serialize(),
        success: function (lineItem) {
          $.getJSON('/cart.js', function (cart) {
            theme.cache.$cartCount.text('(' + cart.item_count + ')');
            $('.hidden-count').removeClass('hidden-count');
          });
          $addToCartBtn.removeClass('btn--loading');
          theme.addToCartflip($addToCartBtn);
          theme.popupReminder();
        },
        error: function (XMLHttpRequest, textStatus) {
          var data     = eval('(' + XMLHttpRequest.responseText + ')');
          var response = data.description;
          var status   = XMLHttpRequest.status;
          $addToCartBtn.removeClass('btn--loading');
          if (status === 422 && $('#productSelect option').length === 1) {
            $addToCartBtnText.text("Sold Out");
          }
          else {
            $addToCartBtn.prop('disabled', false).removeClass('disabled');
            $addToCartBtnText.text($addToCartBtn.attr('data-add-to-cart'));
          }
          $addToCartBtn.after('<p class="note errors">' + response + '</p>');
        }
      });
    }
  });
};

theme.toggleMenu = function () {
  var $doc              = $(document);
  var showDropdownClass = 'show-dropdown';

  // Open sub navs on small screens
  theme.cache.$hasDropdownItem.on('click', function (evt) {
    var $el = $(this);

    if (!$el.hasClass(showDropdownClass) && timber.vars.isTouch) {
      evt.preventDefault();
      $el.addClass(showDropdownClass);
      $doc.on('click', handleClickOutsideDropdown);
    }

    function handleClickOutsideDropdown (evt) {
      var $target = $(evt.target);

      if (!$target.is($el) && !$.contains($el[0], $target[0])) {
        $el.removeClass(showDropdownClass);
        $doc.off('click', handleClickOutsideDropdown)
      }
    }
  })
};

/*=========================================================================

 Custom

 =========================================================================*/

/*
 * jQuery doTimeout: Like setTimeout, but better! - v1.0 - 3/3/2010
 * http://benalman.com/projects/jquery-dotimeout-plugin/
 *
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */
(function ($) {
  var a   = {}, c = "doTimeout", d = Array.prototype.slice;
  $[c]    = function () {return b.apply(window, [0].concat(d.call(arguments)))};
  $.fn[c] = function () {
    var f = d.call(arguments), e = b.apply(this, [c + f[0]].concat(f));
    return typeof f[0] === "number" || typeof f[1] === "number" ? this : e
  };

  function b (l) {
    var m = this, h, k = {}, g = l ? $.fn : $, n = arguments, i = 4, f = n[1], j = n[2], p = n[3];
    if (typeof f !== "string") {
      i--;
      f = l = 0;
      j = n[1];
      p = n[2]
    }
    if (l) {
      h = m.eq(0);
      h.data(l, k = h.data(l) || {})
    } else {
      if (f) {
        k = a[f] || (a[f] = {})
      }
    }
    k.id && clearTimeout(k.id);
    delete k.id;

    function e () {
      if (l) {
        h.removeData(l)
      } else {
        if (f) {
          delete a[f]
        }
      }
    }

    function o () {k.id = setTimeout(function () {k.fn()}, j)}

    if (p) {
      k.fn = function (q) {
        if (typeof p === "string") {
          p = g[p]
        }
        p.apply(m, d.call(n, i)) === true && !q ? o() : e()
      };
      o()
    } else {
      if (k.fn) {
        j === undefined ? e() : k.fn(j === false);
        return true
      } else {
        e()
      }
    }
  }
})(jQuery);


// Initialize theme's JS on docready
$(theme.init)

$(document).ready(function () {

  $('.help-module-button').click(function () {
    $('.help-options').slideToggle();
  });

});

// Sticky Nav
$(document).ready(function () {
    checkScroll();

    $(window).scroll(function (event) {
      checkScroll();
    });
});

function checkScroll(){
  var siteNavHeight = $('.site-header').outerHeight() - ($('.site-header #help-module').outerHeight() + $('.site-header .site-nav').outerHeight());
  var stickyNavHeight = $('.site-nav').outerHeight();

  if ($(document).scrollTop() > siteNavHeight) {
    $('.site-nav').addClass('sticky');
    $('.site-header__logo').css('paddingBottom', stickyNavHeight);
    $('.js-sticky-nav').addClass('sticky');
  } else {
    $('.site-nav').removeClass('sticky');
    $('.site-header__logo').css('paddingBottom', '0px');
    $('.js-sticky-nav').removeClass('sticky');
  }
}

// Wishlist
if (document.querySelector('.vault-enquiry-btn')) {
  $(document).ready(function () {
    $('.vault-enquiry-btn').magnificPopup({
      items: [
        {
          src: '.vault-enquiry-popup', // CSS selector of an element on page that should be used as a popup
          type: 'inline'
        }
      ],
      gallery: {
        enabled: false
      },
      closeBtnInside: true,
      mainClass: 'mfp-fade'
    })
  })
}

// Product Collection Logos
$(document).ready(function () {
  $('.product__collection-logos-wrap .js-collection-trigger').click(function () {
    var popup = $(this).data('trigger-popup');
    $('.js-collection-trigger').magnificPopup({
      items: [
        {
          src: '.js-trigger-popup-' + popup, // CSS selector of an element on page that should be used as a popup
          type: 'inline'
        }
      ],
      closeBtnInside: true,
      mainClass: 'mfp-fade'
    })
  })
})

// Product Collection Logos
$(document).ready(function () {
  $('.product__collection-logos-wrap .js-collection-trigger').click(function () {
    var popup = $(this).data('trigger-popup');
    $('.js-collection-trigger').magnificPopup({
      items: [
        {
          src: '.js-trigger-popup-' + popup, // CSS selector of an element on page that should be used as a popup
          type: 'inline'
        }
      ],
      closeBtnInside: true,
      mainClass: 'mfp-fade'
    })
  })
})

$(document).ready(function () {
  // Accordion
  $('body').on('click', '.accordion-toggle', function(e) {
    var $this = $(this),
    $accordion = $this.closest('.accordion'),
    accordionActive = true,
    href = $this.attr('href');

    if($accordion.hasClass('only-laptop-down')) {
      if(window.matchMedia('(min-width: 72em)').matches) {
        accordionActive = false;
      }
    }

    if(accordionActive || href == '#') {
      e.preventDefault();
    }

    if(accordionActive) {
      if($accordion.hasClass('active')) {
        $accordion.removeClass('active').find('.accordion-content').slideUp();
      } else {
        $accordion.addClass('active').find('.accordion-content').slideDown();

        // Close other accordions
        $accordion.parent().parent().find('.accordion').not($accordion).removeClass('active').find('.accordion-content').slideUp();
      }
    }
  });
});

// Product Page
// if ($('.template-product').length) {
//   $(document).ready(function () {

//     var productSliderArgs = {
//       slideshow: false
//     };

//     $('#product-image-slider').flexslider(productSliderArgs);

//     $('.accordion-title').click(function () {
//       $(this).closest('.single-accordion').toggleClass('open');
//     });

//     $('.customise-ring-btn').magnificPopup({
//       items: [
//         {
//           src: '.customise-ring-popup', // CSS selector of an element on page that should be used as a popup
//           type: 'inline'
//         }
//       ],
//       gallery: {
//         enabled: false
//       },
//       closeBtnInside: true,
//       mainClass: 'mfp-fade'
//     });

    // $('.vault-enquiry-btn').magnificPopup({
    //   items: [
    //     {
    //       src: '.vault-enquiry-popup', // CSS selector of an element on page that should be used as a popup
    //       type: 'inline'
    //     }
    //   ],
    //   gallery: {
    //     enabled: false
    //   },
    //   closeBtnInside: true,
    //   mainClass: 'mfp-fade'
    // });

//     $('.click-collect-btn').magnificPopup({
//       items: [
//         {
//           src: '.click-collect-popup', // CSS selector of an element on page that should be used as a popup
//           type: 'inline'
//         }
//       ],
//       gallery: {
//         enabled: false
//       },
//       closeBtnInside: true,
//       mainClass: 'mfp-fade'
//     });

//     $('.click-collect-btn').magnificPopup({
//       items: [
//         {
//           src: '.click-collect-popup', // CSS selector of an element on page that should be used as a popup
//           type: 'inline'
//         }
//       ],
//       gallery: {
//         enabled: false
//       },
//       closeBtnInside: true,
//       mainClass: 'mfp-fade'
//     });

//     $('.ask-an-expert-btn').magnificPopup({
//       items: [
//         {
//           src: '.ask-an-expert-popup', // CSS selector of an element on page that should be used as a popup
//           type: 'inline'
//         }
//       ],
//       gallery: {
//         enabled: false
//       },
//       closeBtnInside: true,
//       mainClass: 'mfp-fade'
//     });

//     $('.send-a-hint-btn').magnificPopup({
//       items: [
//         {
//           src: '.send-a-hint-popup', // CSS selector of an element on page that should be used as a popup
//           type: 'inline'
//         }
//       ],
//       gallery: {
//         enabled: false
//       },
//       closeBtnInside: true,
//       mainClass: 'mfp-fade'
//     });

    // $('.js-collection-trigger').click(function(e){
    //   var popup = $(this).data('trigger-popup');

    //   $.magnificPopup.open({
    //       items: {
    //           src: '.js-trigger-popup-' + popup,
    //           type: 'inline'
    //       },
    //       closeBtnInside: true,
    //       mainClass: 'mfp-fade'
    //   });

    // });



//     /**
//      * Engraving
//      */
//     // const engraveBtn = document.querySelector('.engraving_btn');
//     // if (engraveBtn !== null) {
      
//     //   //engrave form popup
//     //   const engraveForm = document.querySelector('.engraving_form');
//     //   engraveBtn.addEventListener('click', () => {
//     //     engraveForm.classList.toggle('engraving_enabled');
//     //   }); 

//     //   //close form
//     //   const engraveClose = document.querySelector('.engrave-close');
//     //   engraveClose.addEventListener('click', () => {
//     //     engraveForm.classList.toggle('engraving_enabled');
//     //   }); 

//     //   const engraveOverlay = document.querySelector('.overlay');
//     //   engraveOverlay.addEventListener('click', () => {
//     //     engraveForm.classList.toggle('engraving_enabled');
//     //   }); 

//     //   //engrave inscription
//     //   const engraveInscription = document.querySelector('#engraveInscription');
//     //   engraveInscription.addEventListener('input', (e) => {
//     //     const example = document.querySelector('.engraveEx');
//     //     example.textContent = `${e.target.value}`;
        
//     //     if (e.target.value == 0) {
//     //       example.textContent = `W&H`;
//     //     }
//     //   });

//     //   // addedToCart
//     //   const addedToCart = document.querySelector('#CartEngrave');
//     //   addedToCart.addEventListener('click', () => {
//     //     const popupForm = document.querySelector('.form');
//     //     popupForm.classList.toggle('popup-switch');
//     //   });

//     //   // font select option preview
//     //   const fontSelected = document.querySelectorAll('.font-option');
//     //   fontSelected.forEach(item => {
//     //       item.addEventListener('click', (e) => {
//     //         const ex = document.querySelector('.engraveEx');
//     //         ex.style.fontFamily = e.target.innerHTML;

//     //         if (e.target.innerHTML == 'Helvetica Medium') {
//     //           let helvetica = "Helvetica Medium";
//     //           helvetica.replace("Helvetica Medium", "Helvetica");
//     //         }
//     //       });
//     //   });
  
//     //   // selection option - font
//     //   const selection = document.querySelector('.choose-font');
//     //   selection.addEventListener('click', () => {
//     //     const chooseOption = document.querySelector('.choose-option');
//     //     const iconSelect = document.querySelector('.icon-font');

//     //     selection.classList.toggle('disabled');
//     //     chooseOption.classList.toggle('disabled');
//     //     iconSelect.classList.toggle('disabled');
//     //   });

//     //   // selected option - font
//     //   const fontOption = document.querySelectorAll('.font-option');
//     //   fontOption.forEach(item => {
//     //       item.addEventListener('click', (e) => {
//     //         const result = document.querySelector('.grey-font');
//     //         const choosenStyle = document.querySelector('.choose-option');
//     //         const iconSelected = document.querySelector('.icon-font');
//     //         const chosenStyle = document.querySelector('.choose-font');

//     //         result.innerHTML = `${e.target.innerHTML}`;
//     //         choosenStyle.classList.toggle('disabled');
//     //         iconSelected.classList.toggle('disabled');
//     //         chosenStyle.classList.toggle('disabled');
//     //         result.style.color = '#000';

//     //         if (e.target.innerHTML == undefined) {
//     //           result.textContent = `SELECT FONT`;
//     //         }
//     //       });
//     //   });

//     //   // selection option - location
//     //   const location = document.querySelector('.choose-location');
//     //   location.addEventListener('click', () => {
//     //     const chooseOption = document.querySelector('.select-location');
//     //     const iconSelect = document.querySelector('.icon-location');

//     //     location.classList.toggle('disabled');
//     //     chooseOption.classList.toggle('disabled');
//     //     iconSelect.classList.toggle('disabled');
//     //   });

//     //   // selected option - location
//     //   const locationOption = document.querySelectorAll('.location-option');
//     //   locationOption.forEach(item => {
//     //       item.addEventListener('click', (e) => {
//     //         const result = document.querySelector('.grey-location');
//     //         const choosenStyle = document.querySelector('.select-location');
//     //         const iconSelected = document.querySelector('.icon-location');
//     //         const chosenStyle = document.querySelector('.choose-location');

//     //         result.innerHTML = `${e.target.innerHTML}`;
//     //         choosenStyle.classList.toggle('disabled');
//     //         iconSelected.classList.toggle('disabled');
//     //         chosenStyle.classList.toggle('disabled');
//     //         result.style.color = '#000';

//     //         if (e.target.innerHTML == undefined) {
//     //           result.textContent = `SELECT ENGRAVING LOCATION`;
//     //         }
//     //       });
//     //   });

//     //   // selection option - style
//     //   const style = document.querySelector('.choose-style');
//     //   style.addEventListener('click', () => {
//     //     const chooseOption = document.querySelector('.select-style');
//     //     const iconSelect = document.querySelector('.icon-style');

//     //     style.classList.toggle('disabled');
//     //     chooseOption.classList.toggle('disabled');
//     //     iconSelect.classList.toggle('disabled');
//     //   });


//     //   // selected option - style
//     //   const styleOption = document.querySelectorAll('.style-option');
//     //   styleOption.forEach(item => {
//     //       item.addEventListener('click', (e) => {
//     //         const result = document.querySelector('.grey-style');
//     //         const choosenStyle = document.querySelector('.select-style');
//     //         const iconSelected = document.querySelector('.icon-style');
//     //         const chosenStyle = document.querySelector('.choose-style');

//     //         result.innerHTML = `${e.target.innerHTML}`;
//     //         choosenStyle.classList.toggle('disabled');
//     //         iconSelected.classList.toggle('disabled');
//     //         chosenStyle.classList.toggle('disabled');
//     //         result.style.color = '#000';

//     //         if (e.target.innerHTML == undefined) {
//     //           result.textContent = `SELECT ENGRAVING STYLE`;
//     //         }
//     //       });
//     //   });

//     //   // date 
//     //   const dateSelector = document.querySelector('#requiredDate');
//     //   dateSelector.addEventListener('click', () => {
//     //     const dateText = document.querySelector('.requiredDate');
//     //     dateText.style.color = '#000';
//     //   }); 
//     // };       


//     // Youtube Scripts
//     $('.product-video__trigger').click(function(){
//       if ($(this).hasClass('video-open')) {
//         $(this).removeClass('video-open');
//         $('.icon-video-play').show();
//         $('.icon-video-close').hide();
//         $(this).find('span').text('Watch Video');
//         $('.product-video__container').removeClass('active');
//       } else {
//         $(this).addClass('video-open');
//         $('.icon-video-play').hide();
//         $('.icon-video-close').show();
//         $(this).find('span').text('Close Video');
//         $('.product-video__container').addClass('active');
//         // Autoplay video when Watch Video button has been clicked
//         $(".video-wrapper iframe")[0].src += "&autoplay=1";
//       }
//     });

//     // var metalClass = $('#customMetalType').val();
//     // metalClass     = metalClass.replace(' ', '-').toLowerCase();

//     // $('.metal-container').addClass(metalClass);

//     // $('#customMetalType').on('change', function () {
//     //   $('.metal-container').removeClass(metalClass);
//     //   metalClass = $('#customMetalType').val();
//     //   metalClass = metalClass.replace(' ', '-').toLowerCase();
//     //   $('.metal-container').addClass(metalClass);
//     // });

//     var diamondClass = $('#customDiamondShape').val();
//     if (diamondClass) {
//       diamondClass = diamondClass.replace(' ', '-').toLowerCase();

//       $('.diamond-container').addClass(diamondClass);

//       $('#customDiamondShape').on('change', function () {
//         $('.diamond-container').removeClass(diamondClass);
//         diamondClass = $('#customDiamondShape').val();
//         diamondClass = diamondClass.replace(' ', '-').toLowerCase();
//         $('.diamond-container').addClass(diamondClass);
//       });
//     }

//   });
// }

// Ring Collection Scrolling

function scrollToSection (section) {
  $('html, body').animate({
    scrollTop: $('.' + section).offset().top
  }, 600);
}

$(document).ready(function () {
  $('.ring-collection-nav').click(function () {
    var section = $(this).data('section');
    scrollToSection(section);
  });

  $('.gift-wrapping-block #gift-card-check').change(function () {
    if (this.checked) {
      $('.gift-cards').addClass('show-me');
    } else {
      $('.gift-cards').removeClass('show-me');
    }
  });

  $('.gift-cards li').click(function () {
    var $this = $(this);
    var card  = $this.data('cardName');

    $('.gift-cards li').removeClass('active');
    $this.addClass('active');

    $('#card-picture').val(card).change();

  });

  doQuickView();

  $('.cart__remove').on('click', (e) => {

    let engraving = $(e.currentTarget).data('engraving'),
        index = $(e.currentTarget).data('index')
    let engraveData = {
      'attributes[Engraving Required]': "false",
      'attributes[Engraving Style]': "",
      'attributes[Engraving Font]': "",
      'attributes[Engraving Inscription]': "",
      'attributes[Engraving Location]': "",
      'attributes[Engraving Required Date]': "",
      'attributes[Engraving Extra Notes]': "",
      'attributes[Engraving Not Required]': "",
      'attributes[Other Engraving Location]': "",
    }

    let params = {
      type: 'POST',
      url: '/cart/update.js',
      data: engraveData,
      dataType: 'json'
    };

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        line: index,
        quantity: 0
      },
      complete: function() {
        if(engraving) $.ajax(params);
        window.location.reload();
      }
    })
  })

  // popup--vault-enquiry skucode
  let skuCode = $('.product-single__variants option.selected') ? $('.product-single__variants option.selected').data('sku') : $('.product-single .product__sku-code') ? $('.product-single .product__sku-code').attr('data-first-sku') : '';
  $('#ContactFormSku').val(skuCode);
});

function doQuickView () {
  if ($.magnificPopup) {
    $('body.template-collection').magnificPopup({
      delegate: '.js-quick-view',
      type: 'ajax',
      closeBtnInside: true,
      ajax: {
        settings: null,
        cursor: 'mfp-ajax-cur',
        tError: '<a href="%url%">The content</a> could not be loaded.'
      },
      callbacks: {
        parseAjax: function (mfpResponse) {
          mfpResponse.data = $(mfpResponse.data).find('.product-single, .option-callback-script');
        },
        ajaxContentAdded: function () {
          const selector = $('.product-single .product-single__variants');
          let skuCode = $('.product-single .product__sku-code').attr('data-first-sku');
          let price = $('.product-single .product-money').attr('data-first-price');
          let comparePrice = $('.product-single .product-money').attr('data-first-compare-price');

          $(selector).change((val) => {
            skuCode = $(val.target).find(`option[value="${val.target.value}"]`).attr('data-sku');
            price = $(val.target).find(`option[value="${val.target.value}"]`).attr('data-price');
            comparePrice = $(val.target).find(`option[value="${val.target.value}"]`).attr('data-compare-price');
            // Update Skucode
            $('.product-single .product__sku-code span').text(skuCode);
            // Update Price
            $('.product-single .product-money').text(price);
            // Update Compare Price
            $('.product-single .product-single__sale-price .bold-compare-at-money').text(comparePrice);
          });

          $('#product-image-slider').flexslider();
          theme.cache.$addToCartBtn = $('form[action^="/cart/add"] :submit');
          theme.enableAjax();
          var theLink = this.st.el[0].href;
          $('#AddToCartForm').after('<a href="' + theLink + '" class="view-product-details-link">View Product Details</a>');
          // Remove Find in store
          $('.liveStock').remove();
        },
        afterClose: function () {
          if (typeof iwishCheckColl === 'function') {
            iwishCheckColl();
          }
        }
      }
    })
  }

  $('body.template-collection').on('click', '.js-quick-view', function () {
    $(this).siblings('.iWishAddColl').addClass('iwishcheck');
  });
}

jQuery(function ($) {

  // Track form submission
  $('body').on('submit', '#contact_form', function () {
    dataLayer && dataLayer.push({
      'event': 'ask-expert-submitted'
    });

    fbq && fbq('trackCustom', 'ask-expert-submitted');
  });

  // Queen's Bday Popup and Cookies
  function setCookie (cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires     = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/;";
  }

  function getCookie (cname) {
    var name = cname + "=";
    var ca   = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1);
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function checkCookie () {
    var user = getCookie("popup-done");
    if (user != "") {
    } else {
      setTimeout(function () {
        $('.queens-bday-popup').addClass('show-me');
      }, 10000);
      setCookie("popup-done", 'yes', 30);
    }
  }

  $('.queens-bday-popup').click(function (event) {
    if ($('.queens-bday-popup').is(":visible")) {
      $('.queens-bday-popup').removeClass('show-me');
    }
  });

  $('.queens-bday-popup--close').click(function () {
    $('.queens-bday-popup').removeClass('show-me');
  });

  $('.queens-bday-popup--content').click(function (e) {
    e.stopPropagation();
  });

  function initCheckCookie () {
    var user = getCookie("popup-done");
  }

  initCheckCookie();

  sessionStorage.readyforpopup = 'ready';

  if (sessionStorage.readyforpopup && sessionStorage.readyforpopup === 'ready') {
    checkCookie('popup-done');
  }

});

$(function () {

  

  // GDPR cookies bar
  if (!localStorage.getItem('allow_cookies')) {
    $('.cookie-box').addClass('slide-up');
    setTimeout(function(){
      $('.cookie-box').removeClass('hide-cookies');
    }, 2000);
    $('#c-checkbox').on('change', function () {
      localStorage.setItem('allow_cookies', true);
    });
  }

  // GWP popup false
  

})
